
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { fadeIn } from './communityData';
import TranslatedText from '@/TranslatedText';

const CommunityHero: React.FC = () => {
  return (
    <motion.div className="rounded-2xl overflow-hidden mb-8" initial="hidden" animate="visible" variants={fadeIn}>
      <div className="bg-gradient-to-r from-ahavex-blue to-purple-700 text-white p-8 md:p-12">
        <div className="max-w-3xl">
          <motion.h1 
            className="text-3xl md:text-4xl font-bold mb-3" 
            initial={{opacity: 0, y: 20}} 
            animate={{opacity: 1, y: 0}} 
            transition={{delay: 0.2}}
          >
            <TranslatedText text="Ahavex Community" />
          </motion.h1>
          <motion.p 
            initial={{opacity: 0, y: 20}} 
            animate={{opacity: 1, y: 0}} 
            transition={{delay: 0.4}} 
            className="text-lg mb-6 opacity-90 md:text-sm"
          >
            <TranslatedText text="Connect with fellow entrepreneurs, share insights, and grow your business network across Africa." />
          </motion.p>
          <motion.div 
            className="flex flex-wrap gap-3" 
            initial={{opacity: 0, y: 20}} 
            animate={{opacity: 1, y: 0}} 
            transition={{delay: 0.6}}
          >
            <Button size="default" className="bg-white text-ahavex-blue hover:bg-gray-100 text-xs font-normal">
              <TranslatedText text="Join Us" />
            </Button>
            <Button size="default" variant="outline" className="border-white text-white bg-zinc-500 hover:bg-zinc-400">
              <TranslatedText text="Learn More" />
            </Button>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default CommunityHero;
